import React from 'react';
import { connect } from 'react-redux';
import { Area } from './home-area';
import css from '../styles/home-areas.css';

const { Component } = React;

class Areas extends Component {
  render() {
    return (
      <div className="home-areas content-row">
        {this.props.areas.map((area, i) =>
          <Area area={area} key={i} />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    areas: state.areas
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

let AreasContainer = connect(mapStateToProps, mapDispatchToProps)(Areas);

export { Areas, AreasContainer };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Home/components/home-areas.js